<template>
  <div class="user-page full-height">
    <tableCon>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/storageOrders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>仓库保管订单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">订单编号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.id" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">国内运单号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.trackingNumberCn" size="small"
                  @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title">国际运单号:</div>
              <div class="flex1">
                <el-input
                        placeholder="请输入内容"
                        clearable
                        v-model="queryInfo.trackingNumberJpn"
                        size = "small"
                        @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col> -->
            <el-col :span="6" class="display-row">
              <div class="query-title">用户ID:</div>
              <div class="flex1">
                <!--<el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small" @keyup.enter.native="searchList">
                </el-input>-->
                <search-user-id v-model="queryInfo.userName"></search-user-id>
              </div>
            </el-col>
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title">国际物流状态:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.sagawaState" placeholder="请选择" size="small" clearable>
                  <el-option
                    v-for="item in sagawaStateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col> -->
          </el-row>
          <el-row class="search-row">

          <!-- <el-col :span="6" class="display-row">
            <div class="query-title">订单状态:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.orderStatus" placeholder="请选择" size="small" clearable>
                <el-option
                        v-for="item in orderStatusOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col> -->
          <el-col :span="6" class="display-row">
            <div class="query-title">下单开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">下单结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">发送开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.sendTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">发送结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.sendTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="24" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button class="search-btn btn-blue" @click="toSort">排序</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive" >展开</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive" >收起</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="orderList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle"
          v-loading="isLoading" border stripe style="width: 100%" height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column v-for="(item, index) in asyncColumns" :key="index" align="center" :label="item.name" :prop="item.key"
            :width="item.width?item.width:'auto'" :min-width="item.minWidth?item.minWidth:'auto'">
            <template v-slot="scope">
              <!-- 操作 -->
              <div v-if="item.key === 'handle'" style="display: inline-block" class="btn-row">
                <el-button class="list-btn-four btn-blue" @click="toOrderDetail(scope.row)">
                  详情
                </el-button>
                <el-button class="list-btn-four btn-deepblue" v-if="showEditBtn(scope.row.orderStatus)"
                  @click="toEditOrder(scope.row)">编辑</el-button>
                <el-button class="list-btn-four btn-deepblue" v-if="showSplitOrderBtn(scope.row.orderStatus)"
                  @click="splitOrder(scope.row)">拆单</el-button>
                <!-- <el-button
                    class="list-btn-four btn-blue"
                    v-if="showBill(scope.row.orderStatus)"
                    @click="addBill(scope.row)"
                >账单</el-button> -->
                <!-- <el-button
                    class="list-btn-four btn-red"
                    v-if="showSendBill(scope.row.orderStatus)"
                    @click="addSendBill(scope.row)"
                >发送账单</el-button> -->
                <el-button class="list-btn-four btn-blue" @click="remind(scope.row)">
                  提醒
                </el-button>
              </div>
              <!-- 工作签 -->
              <div v-else-if="item.key === 'staffRemark'">
                <el-input type="textarea" @blur="quickSave(scope.row.staffRemark,'5',scope.row.id)" placeholder="请输入采购内容"
                  v-model="scope.row.staffRemark" size="small">
                </el-input>
                <el-input style="padding-top:5px" type="textarea" @change="quickSave(scope.row.checkRemark,'6',scope.row.id)"
                  placeholder="请输入检品内容" v-model="scope.row.checkRemark" size="small">
                </el-input>
              </div>
              <!-- 产品描述 -->
              <div v-else-if="item.key === 'productDesc'">
                <el-input type="textarea" @change="quickSave(scope.row.productDesc,'0',scope.row.id)" placeholder="请输入内容"
                  v-model="scope.row.productDesc" size="small">
                </el-input>
              </div>
              <!-- 国内物流 -->
              <div v-else-if="item.key === 'trackingNumberCn'">
                <div>{{scope.row.trackingNumberCn}}</div>
                <div class="overflowDot" :title="scope.row.cnLogisticsStatus">{{scope.row.cnLogisticsStatus}}</div>
              </div>
              <!-- 国际物流 -->
              <!-- <div v-else-if="item.key === 'trackingNumberJpn'">
                <div>{{scope.row.trackingNumberJpn}}</div>
                <div class="overflowDot" :title="scope.row.sagawaState">{{scope.row.sagawaState}}</div>
              </div> -->
              <!-- 中国运费 -->
              <div v-else-if="item.key === 'chineseFreightFee'">
                <el-input @blur="quickSave(scope.row.chineseFreightFee,'1',scope.row.id)" v-model="scope.row.chineseFreightFee"
                  type="tel" :maxlength="12" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"></el-input>
              </div>
              <!-- 单价 -->
              <div v-else-if="item.key === 'price'">
                <el-input @blur="quickSave(scope.row.price,'2',scope.row.id)" v-model="scope.row.price" type="tel" :maxlength="12"
                  oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
              </div>
              <!-- 用户备注 -->
              <div v-else-if="item.key === 'customerRemark'">
                <el-input type="textarea" placeholder="" v-model="scope.row.customerRemark" size="small" disabled>
                </el-input>
              </div>
              <!-- 购买订单号 -->
              <div v-else-if="item.key === 'buyOrderNumber'">
                <el-input maxlength="50" @blur="quickSave(scope.row.buyOrderNumber,'3',scope.row.id)"
                  v-model="scope.row.buyOrderNumber"></el-input>
              </div>
              <!-- 购买账号 -->
              <div v-else-if="item.key === 'buyAccountId'">
                <el-select v-model="scope.row.buyAccountId" @change="quickSave(scope.row.buyAccountId,'4',scope.row.id)"
                  placeholder="请选择" size="small" clearable>
                  <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <!-- 订单状态 -->
              <div v-else-if="item.key === 'orderStatus'">
                {{scope.row.orderStatus | orderStatusFilter}}
              </div>
              <!-- 商品数量 -->
              <div v-else-if="item.key === 'goodsCount'">
                <div>
                  <span class="table-cell-title-mid">商品数量：</span>
                  <span>{{scope.row.goodsCount}}</span>
                </div>
                <div>
                  <span class="table-cell-title-mid">待装箱数：</span>
                  <span>{{scope.row.waitBoxCount}}</span>
                </div>
                <div>
                  <span class="table-cell-title-mid">退货数量：</span>
                  <span>{{scope.row.refundCount}}</span>
                </div>
                <div>
                  <span class="table-cell-title-mid">销毁数量：</span>
                  <span>{{scope.row.destroyCount}}</span>
                </div>
              </div>
              <!-- 检品 -->
              <div v-else-if="item.key === 'inspection'">
                <span v-if="scope.row.inspection&&scope.row.inspection.length>0">
                  <div v-for="item in scope.row.inspection.split(',')" :key="item">
                    {{item}}
                  </div>
                </span>
              </div>
              <!-- 仓库保管 -->
              <div v-else-if="item.key === 'categoryFlag'">
                {{scope.row.categoryFlag == 0 ? '否' :'是'}}
              </div>
              <!-- 包装意向 -->
              <div v-else-if="item.key === 'putIntent'">
                {{scope.row.putIntent | putIntentFilter}}
              </div>
              <!-- 商品信息 -->
              <div v-else-if="item.key === 'goodsInfo'">
                <div>
                  <span class="table-cell-title-min">颜色：</span>
                  <span>{{scope.row.colour}}</span>
                </div>
                <div>
                  <span class="table-cell-title-min">尺寸：</span>
                  <span>{{scope.row.goodsSize}}</span>
                </div>
                <div>
                  <span class="table-cell-title-min">品番：</span>
                  <span>{{scope.row.goodsNumber}}</span>
                </div>
                <div>
                  <span>工作签：</span>
                  <span>{{scope.row.customerWorkRemark}}</span>
                </div>
              </div>
              <!-- 图片 -->
              <div v-else-if="item.key === 'picture'">
                <img @paste="onPasteUpload" @click="imgclick(scope.row,scope.$index)"
                  v-if="scope.row.pictureUrl&&scope.row.pictureUrl.length>0" :src="scope.row.pictureUrl" alt=""
                  class="list-image">
                <img v-else @click="imgclick(scope.row,scope.$index)" src="@/assets/images/default.png" alt="" class="list-image">
                <div class="btn-row">
                  <el-button class="list-btn-four btn-blue" @click="toGoodsDetail(scope.row)">
                    商品详情
                  </el-button>
                </div>
              </div>
              <div v-else-if="item.key === 'shippingAddress'" style="text-align: left">
                <!-- 姓名 -->
                <div>
                  <span>姓名：</span>
                  <span>{{scope.row.recipientName}}</span>
                </div>
                <!-- 电话 -->
                <div>
                  <span>电话：</span>
                  <span>{{scope.row.deliveryPhone}}</span>
                </div>
                <!-- 邮编 -->
                <div>
                  <span>邮编：</span>
                  <span>{{scope.row.zipCode}}</span>
                </div>
                <!-- 省市区 -->
                <div>
                  <span>地区：</span>
                  <span>{{scope.row.deliveryArea}}</span>
                </div>
                <!-- 详细地址 -->
                <div>
                  <span>详细地址：</span>
                  <span>{{scope.row.deliveryAddress}}</span>
                </div>
              </div>
              <!-- 其他不需要处理的 -->
              <span v-else>
                {{scope.row[item.key]}}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="订单操作" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button
                    class="list-btn-four btn-blue"
                    @click="toOrderDetail(scope.row)"
                >
                  详情
                </el-button>
              </div>
              <div class="btn-row" v-if="showEditBtn(scope.row.orderStatus)">
                <el-button
                    class="list-btn-four btn-deepblue"
                    @click="toEditOrder(scope.row)"
                >编辑</el-button>
              </div>
              <div class="btn-row" v-if="showSplitOrderBtn(scope.row.orderStatus)">
                <el-button
                    class="list-btn-four btn-deepblue"
                    @click="splitOrder(scope.row)"
                >拆单</el-button>
              </div>
              <div class="btn-row" v-if="showBill(scope.row.orderStatus)">
                <el-button
                    class="list-btn-four btn-blue"
                    @click="addBill(scope.row)"
                >账单</el-button>
              </div>
              <div class="btn-row" v-if="showSendBill(scope.row.orderStatus)">
                <el-button
                    class="list-btn-four btn-red"
                    @click="addSendBill(scope.row)"
                >发送账单</el-button>
              </div>
              <div class="btn-row">
                <el-button
                    class="list-btn-four btn-blue"
                    @click="remind(scope.row)"
                >
                  提醒
                </el-button>
              </div>
            </template>
          </el-table-column> -->

          <!-- <el-table-column prop="id" align="center" label="订单编号" width="70"></el-table-column> -->
          <!-- <el-table-column prop="userName" label="用户ID"></el-table-column> -->
          <!-- <el-table-column prop="staffRemark" label="工作签" width="90">
            <template v-slot="scope">
              <el-input type="textarea" @blur="saveRemark(scope.row)" placeholder="请输入内容" v-model="scope.row.staffRemark" size="small">
              </el-input>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="国内物流" min-width="150">
            <template v-slot="scope">
              <div>{{scope.row.trackingNumberCn}}</div>
              <div class="overflowDot" :title="scope.row.cnLogisticsStatus">{{scope.row.cnLogisticsStatus}}</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="cn_logistics_status" label="国际物流" min-width="150">
            <template v-slot="scope">
              <div>{{scope.row.trackingNumberJpn}}</div>
              <div class="overflowDot" :title="scope.row.sagawaState">{{scope.row.sagawaState}}</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="orderStatus" label="订单状态" align="center" width="70">
            <template v-slot="scope">
              {{scope.row.orderStatus | orderStatusFilter}}
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="是否fba" align="center" width="70">
            <template v-slot="scope">
              {{scope.row.orderType | ordertypeFilter}}
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="商品数量" align="center" min-width="120">
            <template v-slot="scope">
              <div>
                <span class="table-cell-title-mid">商品数量：</span>
                <span>{{scope.row.goodsCount}}</span>
              </div>
              <div>
                <span class="table-cell-title-mid">待装箱数：</span>
                <span>{{scope.row.waitBoxCount}}</span>
              </div>
              <div>
                <span class="table-cell-title-mid">退货数量：</span>
                <span>{{scope.row.refundCount}}</span>
              </div>
              <div>
                <span class="table-cell-title-mid">销毁数量：</span>
                <span>{{scope.row.destroyCount}}</span>
              </div>
            </template>
          </el-table-column>           -->
          <!-- <el-table-column prop="createTime" label="下单日" width="160">
              <template v-slot="scope">
                {{scope.row.createTime | dateFormatToSecond}}
              </template>
          </el-table-column>
          <el-table-column prop="sendTime" label="发送日" width="160">
            <template v-slot="scope">
              {{scope.row.sendTime | dateFormatToSecond}}
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="inspection" label="检品" min-width="150">
            <template v-slot="scope">
              <span v-if="scope.row.inspection&&scope.row.inspection.length>0">
                <div v-for="item in scope.row.inspection.split(',')" :key="item">
                  {{item}}
                </div>
              </span>
            </template>
          </el-table-column> -->

          <!-- <el-table-column prop="categoryFlag" align="center" label="仓库保管" width="70">
            <template v-slot="scope">
              {{scope.row.categoryFlag == 0 ? '否' :'是'}}
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="locatorNo" label="库位"></el-table-column> -->
          <!-- <el-table-column align="center" width="70" label="包装意向">
            <template v-slot="scope">
              {{scope.row.putIntent | putIntentFilter}}
            </template>
          </el-table-column> -->

          <!-- <el-table-column label="商品信息" min-width="130">
            <template v-slot="scope">
              <div>
                <span class="table-cell-title-min">颜色：</span>
                <span>{{scope.row.colour}}</span>
              </div>
              <div>
                <span class="table-cell-title-min">尺寸：</span>
                <span>{{scope.row.goodsSize}}</span>
              </div>
              <div>
                <span class="table-cell-title-min">品番：</span>
                <span>{{scope.row.goodsNumber}}</span>
              </div>
            </template>
          </el-table-column> -->
          <!--          <el-table-column prop="goodsNumber" label="品番"></el-table-column>-->
          <!-- <el-table-column label="图片">
            <template slot-scope="scope">
              <img @click="imgclick(scope.row.pictureUrl,true)" v-if="scope.row.pictureUrl&&scope.row.pictureUrl.length>0" :src="scope.row.pictureUrl" alt="" class="list-image">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image">
              <div class="btn-row">
                <el-button
                    class="list-btn-four btn-blue"
                    @click="toGoodsDetail(scope.row)"
                >
                  商品详情
                </el-button>
              </div>
            </template>
          </el-table-column> -->

          <!-- <el-table-column prop="badCount" align="center" label="不良数量" :index="indexMethod" width="90"></el-table-column> -->
          <!--          <el-table-column prop="exchangCount" label="换货中" :index="indexMethod"  sortable width="90" ></el-table-column>-->
          <!--          <el-table-column prop="reissueCount" label="补发中" :index="indexMethod"  sortable  width="90"></el-table-column>-->
          <!--          <el-table-column prop="refundCount" label="退货数量" :index="indexMethod"  sortable  width="100"></el-table-column>-->
          <!--          <el-table-column prop="destroyCount" label="销毁数量" :index="indexMethod"  sortable  width="100"></el-table-column>-->
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </tableCon>
    <!-- 拆单 -->
    <el-dialog title="拆单" :visible.sync="splitDialogVisible" width="90%" @close="splitDialogClosed">
      <el-row>
        <el-col :span="12" class="split-col">
          <el-form label-width="120px" class="demo-ruleForm">
            <div class="split-title">
              原订单信息：
            </div>
            <div>
              <el-form-item label="原订单编号：">
                <el-input v-model="orginSplitOrderInfo.id" disabled></el-input>
              </el-form-item>
              <el-form-item label="订单状态">
                <el-select v-model="orginSplitOrderInfo.orderStatus" placeholder="请选择" size="small" disabled>
                  <el-option v-for="(item,index) in orderStatusOptions" :key="index" :value="item.value" :label="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数量">
                <el-input v-model="orginSplitOrderInfo.goodsCount" disabled></el-input>
              </el-form-item>
              <el-form-item label="退货数">
                <el-input v-model="orginSplitOrderInfo.refundCount" disabled></el-input>
              </el-form-item>
              <el-form-item label="销毁数">
                <el-input v-model="orginSplitOrderInfo.destroyCount" disabled></el-input>
              </el-form-item>
              <el-form-item label="FBA/YFF/ZOZO/RSL">
                <el-select v-model="orginSplitOrderInfo.orderType" placeholder="请选择" size="small" disabled>
                  <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="仓库保管">
                <el-select v-model="orginSplitOrderInfo.categoryFlag" placeholder="请选择" size="small" disabled>
                  <el-option key="1" value="1" label="是"></el-option>
                  <el-option key="0" value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
        <el-col :span="12" class="split-col">
          <el-form :model="splitOrderInfo" label-width="120px" class="split-form" :rules="splitFormRules" ref="splitOrderInfo">
            <div class="split-title">
              拆出订单信息：
            </div>
            <div>
              <el-form-item label="订单状态">
                <el-select v-model="splitOrderInfo.orderStatus" placeholder="请选择" size="small" disabled>
                  <el-option v-for="(item,index) in orderStatusOptions" :key="index" :value="item.value" :label="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="FBA/YFF/ZOZO/RSL">
                <el-select v-model="splitOrderInfo.orderType" placeholder="请选择" size="small" disabled>
                  <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="仓库保管">
                <el-select v-model="splitOrderInfo.categoryFlag" placeholder="请选择" size="small" disabled>
                  <el-option key="1" value="1" label="是"></el-option>
                  <el-option key="0" value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数量" prop="goodsCount">
                <el-input v-model="splitOrderInfo.goodsCount"></el-input>
              </el-form-item>
              <el-form-item label="退货数" prop="refundCount">
                <el-input v-model="splitOrderInfo.refundCount"></el-input>
              </el-form-item>
              <el-form-item label="销毁数" prop="destroyCount">
                <el-input v-model="splitOrderInfo.destroyCount"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="splitDialogVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="splitSave('splitOrderInfo')">提 交</el-button>
      </span>
    </el-dialog>
    <!-- <MessageTip :visiable.sync="replyDialogVisible" :userName="replyMessageInfo.userName" messageType="订单消息"
      :orderNo="replyMessageInfo.id" httpUrl="cms/inBox/reply" @confirm="onConfirmMsg"></MessageTip> -->
    <MessageTip :visiable.sync="replyDialogVisible" :info="{...replyMessageInfo, orderId: replyMessageInfo.id}" @confirm="onConfirmMsg"></MessageTip>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="bigvisible" width="30%" :show-close="false" :close-on-click-modal="false" center>
      <el-upload class="editor-slide-upload bigimg" action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com" :data="imgDataObj"
        :multiple="false" ref="uploads" :file-list="replyInfo.imgFileList" :show-file-list="true" list-type="picture-card"
        :on-remove="handleImgRemove2" :on-success="handleImgSuccess2" :before-upload="beforeImgUpload" :limit="1">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>

      <div style="text-align:right;">
        <el-button class="form-btn btn-gray" @click="imgDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="imgSave('replyInfo')">提 交</el-button>
      </div>
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>
  </div>
</template>

<script>
import { columns as originColumns } from "./storageOrdersColumns";
import { filterList } from "@/assets/js/utils";
import LxSort from "@/components/LxSort/index";
import Oss from "../../assets/js/oss.js";
import tableCon from "../../views/tableContainer";
import MessageTip from '@/components/MessageTip/index'
export default {
  name: 'storageOrders',
  components: {
    LxSort,
    tableCon, MessageTip
  },
  data () {
    //自定义校验产品数量
    const checkGoodsCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) <= 0 || parseInt(value) >= parseInt(this.orginSplitOrderInfo.goodsCount)) {
          callback(new Error("数量应大于0小于原数量"));
        }
        callback();
      } else {
        callback(new Error("请输入数量"));
      }
    };
    const checkRefundCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) < 0 || parseInt(value) > parseInt(this.orginSplitOrderInfo.refundCount)) {
          callback(new Error("退货数应大于等于0小于等于原退货数"));
        }
        callback();
      } else {
        callback(new Error("请输入退货数"));
      }
    };
    const checkDestroyCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) < 0 || parseInt(value) > parseInt(this.orginSplitOrderInfo.destroyCount)) {
          callback(new Error("销毁数应大于等于0小于等于原销毁数"));
        }
        callback();
      } else {
        callback(new Error("请输入销毁数"));
      }
    };
    return {
      isActive:false,
      buyAcountList: [],
      curIndex: 0, // 默认选中第0个
      isLoading: true,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      orderList: [],
      menuSettingData: {
        menuId: 'staffStorageOrders'
      },
      visible: false,
      imgurl: '',
      queryInfo: {
        id: '',
        trackingNumberCn: '',
        trackingNumberJpn: '',
        sagawaState: '',
        orderStatus: '',
        customerName: '',
        userName: '',
        receiver: '',
        categoryFlag: '',
        createTimeStart: '',
        createTimeEnd: '',
        sendTimeStart: '',
        sendTimeEnd: '',
        orderType: '',
        pageSize: 10,
        pageNum: 1,
      },
      // orderDateRangeValue:'',
      // shipDateRangeValue:[],
      sagawaStateOptions: [
        {
          value: '1',
          label: '黄金糕'
        }, {
          value: '2',
          label: '双皮奶'
        }, {
          value: '3',
          label: '蚵仔煎'
        }, {
          value: '4',
          label: '龙须面'
        }, {
          value: '5',
          label: '北京烤鸭'
        }
      ],
      fbaOption: [
        {
          label: '否',
          value: '1'
        },
        {
          label: 'FBA',
          value: '0'
        },
        {
          label: 'YFF',
          value: '2'
        },
        {
          label: 'ZOZO',
          value: '3'
        },
        {
          label: 'RSL',
          value: '4'
        },
      ],
      orderStatusOptions: [],
      splitDialogVisible: false,
      orginSplitOrderInfo: {},
      splitOrderInfo: {},
      splitForm: {},
      total: 0,
      splitFormRules: {
        goodsCount: [
          { required: true, message: "请输入数量", trigger: "change" },
          { validator: checkGoodsCount }
        ],
        refundCount: [
          { required: true, message: "请输入退货数", trigger: "change" },
          { validator: checkRefundCount }
        ],
        destroyCount: [
          { required: true, message: "请输入销毁数", trigger: "change" },
          { validator: checkDestroyCount }
        ]
      },
      rules: {
        remindingTitle: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        remindingContent: [
          { required: true, message: '请输入回复内容', trigger: 'blur' }
        ]
      },
      replyMessageInfo: {},
      replyDialogVisible: false,
      // 图片粘贴相关
      bigvisible: false,
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      replyInfo: {
        orderId: '',
        remindingUserName: '',
        remindingTitle: '',
        remindingTitleJa: '',
        remindingContent: '',
        url: '',
        replyPicture: '',
        imgFileList: [],
        imgFileListStr: ''
      },
      bigimglist: {
        orderId: '',
        pictureUrl: '',
        upfile: '',
      },
      listObj: [],
      // picture end
    };
  },
  created () {
    this.orderStatusOptions = [
      {
        value: '0',
        label: '等待到库'
      },
      {
        value: '4',
        label: '到库'
      },
      {
        value: '8',
        label: '检品中'
      },
      {
        value: '12',
        label: '检品完'
      },
      {
        value: '16',
        label: '仓库保管中'
      },
      {
        value: '20',
        label: '申请发货'
      },
      {
        value: '24',
        label: '不良待处理'
      },
      {
        value: '26',
        label: '不良驳回'
      },
      {
        value: '28',
        label: '换货待发回'
      },
      {
        value: '32',
        label: '换货等待到货'
      },
      {
        value: '36',
        label: '待部分退货'
      },
      {
        value: '40',
        label: '补发等待到货'
      },
      {
        value: '44',
        label: '待支付'
      },
      {
        value: '48',
        label: '待发送'
      },
      {
        value: '52',
        label: '已发送'
      },
      {
        value: '56',
        label: '已取消'
      },
      {
        value: '60',
        label: '退货申请中'
      },
      {
        value: '64',
        label: '退货待支付'
      },
      {
        value: '68',
        label: '待退货'
      },
      {
        value: '72',
        label: '已退货'
      },
      {
        value: '76',
        label: '销毁申请中'
      },
      {
        value: '80',
        label: '销毁待支付'
      },
      {
        value: '82',
        label: '待部分销毁'
      },
      {
        value: '84',
        label: '已销毁'
      },
      {
        value: '88',
        label: '装箱中'
      },
    ];
    this.getAsyncColumns().then(() => {
      this.getOrderList();
      this.getBuyAccountList();
    });
  },
  methods: {
    // picture Ctrl+V start
    imgclick (url, index) {
      this.index = index
      this.bigvisible = true
      if (url.pictureUrl == "" || url.pictureUrl == undefined) {
        this.$nextTick(() => {
          var su = document.getElementsByClassName('el-upload--picture-card')[0]
          su.style.display = 'block'
          this.replyInfo.imgFileList = []
        })
      } else {
        this.$nextTick(() => {
          var su = document.getElementsByClassName('el-upload--picture-card')[0]
          su.style.display = 'none'
          this.replyInfo.imgFileList = [{
            url: url.pictureUrl
          }]
        })
      }
      this.bigimglist.orderId = url.id
      var su = document.getElementsByClassName('el-upload-list__item')[0]
      document.addEventListener('paste', this.onPasteUpload)
    },
    onConfirmMsg () {
      this.replyDialogVisible = false
      this.getOrderCount();
      this.getOrderList()
    },
    onPasteUpload (event) {
      event.stopPropagation()
      let text = (event.clipboardData || window.clipboardData);
      this.bigimglist.upfile = text.files[0]
      this.bigimglist.pictureUrl = ''
      if (text.files[0] === null) {
        this.$message.error('仅支持图片文件')
      } else {
        // 将文件流转换为img认识的格式放在页面
        let blob = new Blob([text.files[0]]); // 返回的文件流数据
        let url = window.URL.createObjectURL(blob); // 将他转化为路径
        this.replyInfo.imgFileList = [{ url }]
        var su = document.getElementsByClassName('el-upload--picture-card')[0]
        this.$nextTick(() => {
          su.style.display = 'none'
        })
      }
    },
    handleImgRemove2 (file) {
      Oss.imgRemove(file, this.listObj);
      var su = document.getElementsByClassName('el-upload--picture-card')[0]
      this.$nextTick(() => {
        su.style.display = 'block'
      })
      this.bigimglist.upfile = ''
      this.bigimglist.pictureUrl = ''
    },
    handleImgSuccess2 (response, file, fileList) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj)
      var su = document.getElementsByClassName('el-upload--picture-card')[0]
      this.$nextTick(() => {
        su.style.display = 'none'
      })

    },
    beforeImgUpload (file) {
      const _self = this;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http.get('aliyun/oss/policy').then(response => {
          var num = "";   //定义编号
          for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
          {
            num += Math.floor(Math.random() * 10);
          }
          num = new Date().getTime() + num;  //时间戳，用来生成编号。
          _self.imgDataObj.policy = response.data.data.policy;
          _self.imgDataObj.signature = response.data.data.signature;
          _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
          _self.imgDataObj.key = response.data.data.dir + '/order/' + num + '${filename}';
          _self.imgDataObj.dir = response.data.data.dir + '/order';
          _self.imgDataObj.host = response.data.data.host;
          _self.imgDataObj.timeStamp = num;
          Oss.imgCompress(file, this.listObj, resolve, reject)
        }).catch(err => {
          reject(true)
        })
      })
    },
    imgDialogClose () {
      this.bigvisible = false
      if (this.replyInfo.imgFileList.length === 0) {
        var su = document.getElementsByClassName('el-upload--picture-card')[0]
        this.$nextTick(() => {
          su.style.display = 'block'
        })
      } else {
        var su = document.getElementsByClassName('el-upload--picture-card')[0]
        this.$nextTick(() => {
          su.style.display = 'none'
        })
      }
    },
    imgSave () {
      this.handleImgSubmit();

      if (this.replyInfo.replyPicture.indexOf(',')) {
        this.replyInfo.replyPicture = this.replyInfo.replyPicture.split(',')[1]
      }

      if (this.bigimglist.upfile === '') {
        this.bigimglist.pictureUrl = this.replyInfo.replyPicture
      } else {
        this.bigimglist.pictureUrl = ''
      }
      this.replyInfo.imgFileList = this.replyInfo.imgFileList.splice(1, 1)
      this.uploadFile()
    },
    handleImgSubmit () {
      var _this = this;
      const arr = Object.keys(_this.listObj).map(v => _this.listObj[v]);
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
        return
      }
      else {
        if (arr.length > 1) {
          _this.$message.error('最多可上传1张图片');
        }
        else {
          _this.replyInfo.imgFileList = _this.replyInfo.imgFileList.concat(arr);
          var urlArr = [];
          _this.replyInfo.imgFileList.forEach(el => {
            urlArr.push(el.url);
          })
          _this.replyInfo.replyPicture = urlArr.toString();
          _this.$emit('successCBK', arr);
          _this.listObj = {};
          _this.imgDialogVisible = false;
        }
      }
    },
    async uploadFile () {
      var formdata = new FormData
      formdata.append('orderId', this.bigimglist.orderId)
      var su = this.orderList[this.index].pictureUrl
      this.bigimglist.pictureUrl === undefined ? formdata.append('pictureUrl', su) : formdata.append('pictureUrl', this.bigimglist.pictureUrl)

      formdata.append('upfile', this.bigimglist.upfile)
      const { data: res } = await this.$http.post("order/uploadFile", formdata);
      if (res.code === 200) {
        this.$message.success('上传成功')
        this.bigvisible = false;
        this.getOrderList();
      } else {
        this.$message.error(res.message)
      }
    },
    // picture Ctrl+V start
    // // 粘贴上传图片
    async handlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片");
        return;
      }
      let formdata = new FormData();
      formdata.append('file', file);
      const { data: res } = await this.$http.post('cmUser/message/uploadFile', formdata);
      if (res.code === 200) {
        this.replyInfo.fileName = res.data.fileName
        this.replyInfo.filePath = res.data.filePath
        this.replyInfo.imgFileList.push({
          name: res.data.fileName,
          url: res.data.filePath
        })
      }
    },
    //快速保存
    async quickSave (value, type, id) {
      if (type === '0') {
        const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, productDesc: value, quickSaveType: type });
      } else if (type === '1') {
        if (!value && value !== 0) {
          this.$message.error('中国运费不能设置为空')
        } else if ((value.split('')[0] == 0 && value.split('')[1] == 0) || (value.split('')[0] == 0 && value.split('').length > 1 && value.split('')[1] !== '.')) {
          this.$message.error('请正确输入运费！')
        } else {
          const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, chineseFreightFee: value, quickSaveType: type });
        }
      } else if (type === '2') {
        if (value && Number(value) > 0) {
          const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, price: value, quickSaveType: type });
        } else {
          this.$message.error('单价不能设置为空')
        }
      } else if (type === '3') {
        const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, buyOrderNumber: value, quickSaveType: type });
      } else if (type === '4') {
        const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, buyAccountId: value, quickSaveType: type });
      } else if (type === '5') {
        const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, staffRemark: value, quickSaveType: type });
      } else if (type === '6') {
        const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, checkRemark: value, quickSaveType: type });
      }
    },
    //获取购买账号
    getBuyAccountList () {
      this.$http.get('cms/configAccountNumber/getAllList').then(res => {
        this.buyAcountList = res.data.data;
        this.buyAcountList.map(res => {
          if (res.platformType !== null) {
            switch (res.platformType) {
              case '0':
                return res.platformType_hanzi = '淘宝 -' + res.accountNumber
                break;
              case '1':
                return res.platformType_hanzi = '1688 -' + res.accountNumber
                break;
              case '2':
                return res.platformType_hanzi = '京东 -' + res.accountNumber
                break;
              case '3':
                return res.platformType_hanzi = '拼多多 -' + res.accountNumber
                break;
              case null:
                return res.platformType_hanzi = ''
                break;

            }
          }
        })
      })
    },
    // 获取已选择列
    getAsyncColumns () {
      return new Promise((resolve) => {
        // 接口start
        this.$http.get("menu/menuSetting", {
          params: {
            menuId: 'staffStorageOrders'
          }
        }).then((res) => {
          var result = [];
          if (res.data.code === 200) {
            var record = res.data.data;
            this.menuSettingData = record;
            result = JSON.parse(record.menuSetting);
          }
          if (result && result.length > 0) {
            result.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            let noSelectList = filterList(
              this.originColumns,
              result,
              "columnId"
            );
            this.columns = result.concat(noSelectList);
            this.asyncColumns = result;
            resolve();
          } else {
            this.columns = this.originColumns;
            this.columns.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            this.asyncColumns = this.columns;
            resolve();
          }
        });
      });
    },
    // 保存选择的列
    doSaveColumns (list) {
      var my = this;
      // 接口
      let url = "menu/updateMenuSetting";
      this.menuSettingData.menuSetting = JSON.stringify(list);
      this.$http.post(url, this.menuSettingData).then(res => {
        if (res.data.code === 200) {
          this.isVisibleSort = false;
          my.$message({
            type: "success",
            message: "保存成功",
          });
          this.queryInfo.pageNum = 1;
          this.getAsyncColumns().then(() => {
            this.getOrderList();
          });
        } else {
          my.$message({
            type: "warning",
            message: "保存失败",
          });
        }
      })
    },
    // 排序
    toSort () {
      this.isVisibleSort = true;
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    orderDateRange () {
    },
    shipDateRange () {
    },
    //拆单按钮显示
    showSplitOrderBtn (status) {
      if (status == 0 || status == 4 || status == 8 || status == 12 || status == 16 || status == 48) {
        return true;
      } else {
        return false;
      }
    },//编辑按钮显示
    showEditBtn (status) {
      if (status != 52 && status != 72 && status != 84 && status != 56) {
        return true;
      } else {
        return false;
      }
    },
    //账单按钮显示   已销毁84 已退货72 已发送52 待退货68 装箱中88 待发送48 销毁待支付80 待支付44 退货待支付64
    showBill (status) {
      if (status == 84 || status == 72 || status == 52 || status == 68 || status == 88 || status == 48 || status == 80 || status == 44 || status == 64) {
        return true;
      }
      else {
        return false;
      }
    },
    //发送账单按钮显示  检品完12 申请发货20 退货申请中60 销毁申请中76
    showSendBill (status) {
      if (status == 12 || status == 20 || status == 60 || status == 76) {
        return true;
      }
      else {
        return false;
      }
    },
    addBill (e) {
      this.$router.push({
        path: 'orders/bill',
        query: {
          id: e.id,
          isAdd: '0',
          //orderNumber:e.orderNumber,
        }
      })
    },
    addSendBill (e) {
      this.$router.push({
        path: 'orders/bill',
        query: {
          id: e.id,
          isAdd: '1',
          //orderNumber:e.orderNumber,
        }
      })
    },
    queryInfoClear () {
      this.queryInfo = {
        id: '',
        trackingNumberCn: '',
        trackingNumberJpn: '',
        sagawaState: '',
        orderStatus: '',
        customerName: '',
        receiver: '',
        categoryFlag: '',
        createTimeStart: '',
        createTimeEnd: '',
        sendTimeStart: '',
        sendTimeEnd: '',
        orderType: '',
        pageSize: 10,
        pageNum: 1
      }
      // this.orderDateRangeValue = '';
      // this.shipDateRangeValue = [];
    },
    searchList () {
      this.queryInfo.pageNum = 1;
      this.getOrderList();
    },
    categoryFlagChanged (row) {
      //改变状态接口 params row.No,row.categoryFlag
      setTimeout(() => {
        row.categoryFlag = !row.categoryFlag;
        alert('failed')
      }, 1000);

    },
    async getOrderList () {
      this.isLoading = true;
      const { data: res } = await this.$http.get("storageOrder/list", { params: this.queryInfo });
      this.orderList = res.data.list;
      this.total = res.data.total;
      this.isLoading = false;
    },
    toOrderDetail (row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.id,
          isEdit: '0'
        }
      })
    },
    toGoodsDetail (row) {
      this.$http.post("/order/changeUrl", { taobaoUrl: row.taobaoUrl }).then(res => {
        const changeUrl = res.data.data;
        window.open(changeUrl, '_blank')
      });
    },
    toEditOrder (row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.id,
          isEdit: '1'
        }
      })
    },
    splitOrder (row) {
      this.splitDialogVisible = true;
      this.orginSplitOrderInfo = row;
      this.splitOrderInfo = JSON.parse(JSON.stringify(row));
    },
    splitDialogClosed () {
      this.splitDialogVisible = false;
    },
    splitSave (formName) {
      this.$refs[formName].validate(async (valid) => {
        let params = {
          id: this.splitOrderInfo.id,
          goodsCount: this.splitOrderInfo.goodsCount,
          refundCount: this.splitOrderInfo.refundCount,
          destroyCount: this.splitOrderInfo.destroyCount,
        }
        if (valid) {
          const { data: res } = await this.$http.post('empArrOrder/spilt', params);
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.message
            })
            this.splitDialogClosed();
            await this.getOrderList();
          } else {
            this.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      });
    },
    saveRemark (row) {
      this.savePost(row);
    },
    async savePost (row) {
      const { data: res } = await this.$http.post('order/updateOrderInfo', { orderId: row.id, staffRemark: row.staffRemark });
      if (res.code == 200) {
        this.getOrderList();
      }
      else {
        this.$message.error(res.message);
      }
    },
    replySave (formName) {    //提醒弹窗保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addReply();
          this.replyDialogVisible = false;
          this.btnReplyFlag == 0;
        } else {
          this.$message.error('必填项不能为空，请重新填写并提交！');
          return false;
        }
      });
    },
    remind (row) {     //提醒
      this.handleImgSubmit();
      this.replyDialogVisible = true;
      this.replyMessageInfo = row;
      this.replyInfo = {
        orderId: row.id,
        remindingUserName: row.customerName,
        imgFileList: []
      };
    },
    clearReplyForm () {   //弹窗的取消按钮
      this.initReplyForm();
      this.replyDialogVisible = false;
    },
    initReplyForm () {   //初始化弹窗的内容
      this.replyInfo = {
        remindingContent: '',
        remindingTitle: '',
        replyPicture: ''
      };
    },
    replyDialogClose () {    //关闭提醒弹窗
      this.replyDialogVisible = false;
    },
    async addReply () {    //添加
      this.handleImgSubmit();
      var url = 'cms/inBox/reply';
      const { data: res } = await this.$http.post(url, this.replyInfo);
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
      }
      else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    showImgDialog (index) {
      this.imgDialogVisible = true;
    },
    handleImgSubmit () {
      var _this = this;
      const arr = Object.keys(_this.listObj).map(v => _this.listObj[v]);
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
        return
      }
      else {
        if (arr.length > 1) {
          _this.$message.error('最多可上传1张图片');
        }
        else {
          _this.replyInfo.imgFileList = _this.replyInfo.imgFileList.concat(arr);
          var urlArr = [];
          _this.replyInfo.imgFileList.forEach(el => {
            urlArr.push(el.url);
          })
          _this.replyInfo.replyPicture = urlArr.toString();
          _this.$emit('successCBK', arr);
          _this.listObj = {};
          _this.imgDialogVisible = false;

        }
      }
    },
    handleImgRemove (file, fileList) {
      // 显示使用
      this.replyInfo.imgFileList = fileList
      Oss.imgRemove(file, this.listObj);
    },
    handleImgSuccess (response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
    },
    beforeImgUpload (file) {
      const _self = this;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http.get('aliyun/oss/policy').then(response => {
          var num = "";   //定义编号
          for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
          {
            num += Math.floor(Math.random() * 10);
          }
          num = new Date().getTime() + num;  //时间戳，用来生成编号。
          _self.imgDataObj.policy = response.data.data.policy;
          _self.imgDataObj.signature = response.data.data.signature;
          _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
          _self.imgDataObj.key = response.data.data.dir + '/order/' + num + '${filename}';
          _self.imgDataObj.dir = response.data.data.dir + '/order';
          _self.imgDataObj.host = response.data.data.host;
          _self.imgDataObj.timeStamp = num;
          Oss.imgCompress(file, this.listObj, resolve, reject)
        }).catch(err => {
          reject(false)
        })
      })
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.searchList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.searchList();
    },

  },
  watch: {
    //监听时间选择器绑定值变化
    // orderDateRangeValue(){
    //   //解决时间选择器清空后 绑定值为null问题
    //   if(!this.orderDateRangeValue){
    //     this.orderDateRangeValue = '';
    //     this.queryInfo.createTimeStart = '';
    //     this.queryInfo.createTimeEnd = '';
    //   }
    //   else{
    //     if(this.orderDateRangeValue.length>0){
    //       this.queryInfo.createTimeStart = this.orderDateRangeValue;
    //       this.queryInfo.createTimeEnd = this.orderDateRangeValue;
    //     }
    //   }
    //
    // },
    // shipDateRangeValue(){
    //   if(!this.shipDateRangeValue){
    //     this.shipDateRangeValue =[];
    //     this.queryInfo.sendTimeStart = '';
    //     this.queryInfo.sendTimeEnd = '';
    //   }
    //   else{
    //     if(this.shipDateRangeValue.length>0){
    //       this.queryInfo.sendTimeStart = this.shipDateRangeValue[0];
    //       this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1];
    //     }
    //   }
    // }
  },
  computed: {
    order1 () {
      if (!sessionStorage.getItem('token')) {
        return false;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.paste-img {
  position: absolute;
  top: 0;
  left: 1px;
  width: 1px;
  height: 1px;
  z-index: 999;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}
</style>
<style lang="less" scoped>
/deep/ /*去除upload组件过渡效果*/
.el-upload-list__item {
  transition: none !important;
}
.bigimg /deep/ ul li {
  width: 100%;
  height: auto;
}
.bigimg /deep/ .el-upload--picture-card {
  display: none;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.search-btn-container-status {
  text-align: left !important;
}
.mark {
  background: #dbdb86;
  text-align: left;
  margin-bottom: 10px;
}
.el-icon-close {
  cursor: pointer;
}
</style>
